/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 料金異動情報
 */
export interface Szma202aResponseChargeIdoInfoDto {
    /**
     * 異動年月日：日付(yyyyMMdd)
     */
    idoDate?: string;
    /**
     * 異動種別コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C403480」のユーザコードを設定
     */
    chargeIdoCode?: string;
}

